

// Import translations
import translationEN from './locales/en/translation.json';
import translationIT from './locales/it/translation.json';
import translationFR from './locales/fr/translation.json';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: { translation: translationEN },
  it: { translation: translationIT },
  fr: { translation: translationFR }
};


i18next
  //.use(HttpApi)
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", //default language
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // React already does escaping
    }
  });

export default i18next;
